export const LoginInitialValues = {
  email: "",
  password: "",
}
